export default {

    barColors: {
        "0": "#f00",
        "0.5": "#0f0",
        "1.0": "#00f",
    },
    shadowBlur: 0,
    barThickness: 4
};
